import { Switch } from 'react-router';
export default Switch;
